export default __webpack_public_path__ + "static/media/Hedy.8188d4e0.jpg";